import { useQuery } from "../../Utils/utils"

export const usePageQuery = (search) => {
  const query = useQuery(search)
  return {
    user_id: query.get("user_id"),
    from: query.get("from")
  }
}
